// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wIAg","fullView":"styles_fullView__Irbao"};